import * as React from 'react';
import { getOrderLogEventsApi } from 'src/api/letseatadmin/logEvent/getOrderLogEventsApi';
import { Table } from 'src/components/Table';
import { UpdatingContentProgress } from 'src/components/UpdatingContentProgress';
import { translate } from 'src/i18n/translate';
import type { OrderId } from 'src/types/Id';
import { formatDateTimeSecondsString } from 'src/utils/date/formatDateTimeSecondsString';
import { useLoadApi } from 'src/utils/react/useLoadApi';
import { useParams } from 'src/utils/react/useParams';
import { toShortId } from 'src/utils/uuid/toShortId';

export function OrderLogEvents(): React.ReactElement {
    const { orderId } = useParams<{
        orderId: OrderId;
    }>();
    const [loading, orderLogs] = useLoadApi(getOrderLogEventsApi, { orderId }, { initialValue: [] });

    const columns = [
        {
            name: 'logEventId',
            label: translate('Event Id'),
            options: {
                filter: false,
            },
        },
        {
            name: 'logEventLevel',
            label: translate('Log Level'),
            options: {
                filter: false,
            },
        },
        {
            name: 'logEventType',
            label: translate('Log Type'),
            options: {
                filter: false,
            },
        },
        {
            name: 'message',
            label: translate('Message'),
            options: {
                filter: false,
            },
        },
        {
            name: 'orderId',
            label: translate('Order Id'),
            options: {
                filter: false,
            },
        },
        {
            name: 'restaurantId',
            label: translate('Restaurant Id'),
            options: {
                filter: false,
            },
        },
        {
            name: 'occurredAt',
            label: translate('Occurred At'),
            options: {
                filter: false,
            },
        },
    ];

    return (
        <div style={{ position: 'relative' }}>
            <UpdatingContentProgress loading={loading} />
            <Table
                loading={loading}
                options={{ selectableRows: 'none' }}
                data={
                    orderLogs &&
                    orderLogs?.map((logEvent) => ({
                        logEventId: toShortId(logEvent.logEventId),
                        logEventLevel: logEvent.logEventLevel,
                        logEventType: logEvent.logEventType,
                        message: logEvent.message,
                        orderId: toShortId((logEvent as any).orderId) ?? logEvent.relatedItems?.find((ri) => ri.name === 'orderId')?.value,
                        restaurantId: toShortId((logEvent as any).restaurantId) ?? logEvent.restaurant?.restaurantId,
                        occurredAt: formatDateTimeSecondsString(logEvent.occurredAt),
                    }))
                }
                columns={columns}
            />
        </div>
    );
}
